export const HEADER_BLOCK_S07 = {
  "blockType": "HEADER",
  "blockDesign": "HeaderDesign2",
  "editFormName": "HEADER_04_FORM",
  "styleProps": {
    "background-image": "linear-gradient(to bottom,#e5f0ff,#f0f0f0)",
    "background-color": "#e5f0ff",
    "padding": "120px 20px 120px 20px"
  },
  "textBlock": {
    "styleProps": {
      "background-color": "",
      "border-radius": "0",
      "padding": "10px 10px 10px 10px"
    },
    "stylePropsTab": {},
    "stylePropsMob": {},
    "alingBlock": "center",
    "headings": [
      {
        "text": "☆ 4.9/5 from over 600 reviews",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "4px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.25rem",
          "line-height": "1.75rem",
          "font-weight": "400",
          "font-family-cust": "",
          "font-family": "",
          "background-color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        },
        "alignStyleProps": {
          "text-align": "left",
          "margin": "0px 0px 0px 0px",
          "padding": "0px 20px 10px 20px"
        },
        "stylePropsMob": {
          "font-size": "1.125rem",
          "line-height": "1.75rem"
        },
        "stylePropsTab": {
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        }
      },
      {
        "text": "Transforming Businesses ",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "1px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "4.5rem",
          "line-height": "1",
          "font-family": "'Source Serif 4'",
          "font-weight": "400",
          "font-family-cust": "Source Serif 4",
          "font-family-bk": "'Source Serif 4', cursive"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "10px 20px 10px 20px",
          "margin": "10px 0px 40px 0px"
        },
        "stylePropsMob": {
          "font-size": "3rem",
          "line-height": "1"
        },
        "stylePropsTab": {
          "font-size": "3.75rem",
          "line-height": "1"
        },
        "alignStylePropsTab": {
          "margin": "10px 0px 20px 0px"
        }
      },
      {
        "text": "Empowering growth, efficiency, and success through cutting-edge technology.",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.5rem",
          "line-height": "1.75rem"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "0px 120px 0px 20px"
        },
        "alignStylePropsMob": {
          "padding": "0px 20px 0px 20px"
        },
        "stylePropsTab": {
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        },
        "stylePropsMob": {
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        }
      }
    ],
    "dynamicText": {
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "strings": []
    },
    "descriptionsStyleProps": {
      "padding": "10px 0px 10px 0px",
      "text-align": "center",
      "margin": "0px 0px 0px 0px"
    },
    "descriptionsStylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptionsStylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptions": [],
    "buttonsStyleProps": {
      "margin": "50px 0px 0px 10px"
    },
    "buttonAlign": "start",
    "buttons": [
      {
        "styleProps": {
          "padding": "10px 40px 10px 40px",
          "border-width": "0px",
          "color": "#ffffff",
          "background-color": "#116dff",
          "border-radius": "9999px",
          "font-size": "1.125rem",
          "line-height": "1.75rem"
        },
        "alt": "Google Play Store",
        "href": "#",
        "text": "Get Started",
        "openType": "sametab"
      },
      {
        "text": "Learn more",
        "styleProps": {
          "color": "#333333",
          "background-color": "",
          "border-width": "0px",
          "border-radius": "9999px",
          "padding": "10px 40px 10px 40px",
          "font-weight": "600",
          "font-size": "1.125rem",
          "line-height": "1.75rem"
        },
        "href": "#",
        "openType": "sametab"
      }
    ],
    "emailSecStyleProps": {},
    "subscription": {
      "showSection": "hide",
      "display": "enable",
      "subConfigs": {
        "configType": "convertkit",
        "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
        "configPlaceholder": ""
      },
      "email_placeholder": {
        "text": "example@mail.com"
      },
      "buttonText": {
        "text": "Subscribe",
        "styleProps": {
          "background-color": "#1b1b31",
          "color": "#ffffff"
        }
      },
      "successMessage": {
        "text": "Thank you for the signup",
        "styleProps": {}
      },
      "errorMessage": {
        "text": "Something went wrong. Please try again.",
        "styleProps": {}
      }
    },
    "buttonsStylePropsTab": {
      "margin": "20px 0px 0px 10px"
    }
  },
  "imageType": "image",
  "imageVideoPostion": "right",
  "imageBlock": {
    "image": "https://images.pexels.com/photos/2678468/pexels-photo-2678468.jpeg?auto=compress&cs=tinysrgb&w=600",
    "styleProps": {
      "margin": "0px 0px 0px 0px",
      "border-radius": "0px",
      "background-color": ""
    },
    "imageTag": {
      "styleProps": {
        "border-radius": "1.5rem"
      }
    },
    "tagStyleProps": {
      "border-radius": "1.5rem",
      "border-width": "0px",
      "border-color": "#ffa611"
    }
  },
  "videoBlock": {
    "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    },
    "videoHeight": {
      "height": "400px"
    }
  },
  "htmlBlock": {
    "value": "",
    "styleProps": {}
  },
  "metaDataId": 1745687632880,
  "afterIndex": 0,
  "blockId": 1745687632880,
  "buttons": [
    {
      "text": "Click Here",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "fonts": {
    "textBlock": "Source Serif 4"
  },
  "position": "hide",
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}